





























import { Component, Prop, Watch } from "vue-property-decorator";
import Vue from "vue";
import BaseModel from "@/models/base/BaseModel.model";
import BaseRepository from "@/core/HttpResources/BaseRepository";
import { AxiosResponse } from "axios";
import UserService from "@/services/user.service";
import User from "@/models/security/user.model";

import UserBasicInformationComponent from "@/components/user-basic-information/userBasicInformation.vue";
import BaseApi from "@/core/HttpResources/BaseApi";
import HistoryService from "../../../services/History.service";
import Tag from "@/models/history/tag.model";
import RecordTag from "../../../models/history/recordTag.model";
@Component({
  components: {
    UserBasicInformationComponent
  }
})
export default class BaseSelectTagSearch extends Vue {
  @Prop() public label!: string;
  @Prop() public controller!: string;
  @Prop() public action!: string;
  @Prop() public placeholder!: string;
  @Prop() public disabled!: boolean;
  @Prop({ default: true }) public multiple!: boolean;
  @Prop() public value: any;
  @Prop() public initOnDisable!: boolean;
  @Prop() public hideSelected!: boolean;
  @Prop() public profilePictureCustomClassProp!: string;
  @Prop() public informationCustomClassProp!: string;
  @Prop() public profilePictureCustomPaddingProp!: string;
  @Prop() public informationCustomPaddingProp!: string;
  @Prop() public isInvestigator: boolean;
  @Prop() public isAllUser: boolean;
  @Prop() public excludeId!: number;
  @Prop() public loadOnMount!: boolean;
  @Prop() public loadWhen!: boolean;
  @Prop() public nameValueCode!: string;
  @Prop() public options!: Array<any>;
  @Prop() public dependencyKey!: string;
  @Prop() public dependecyValue!: string;
  @Prop() public openDirection!: string;
  @Prop() public size!: string;
  @Prop() public dbTags!: any;

  @Prop() public isQueryString!: boolean;
  @Prop() public allowEmpty!: boolean;
  @Prop() public searchPersonById!: boolean;

  userService: UserService = new UserService();
  historyService: HistoryService = new HistoryService();

  selected: any = null;
  data: any = [];
  loading: boolean = false;
  nombre: any = null;
  sLoadOnMount = this.loadOnMount === false ? false : true;
  timerFunction: any;

  profilePictureCustomClass;
  informationCustomClass;
  profilePictureCustomPadding;
  informationCustomPadding;

  disabledAdd: boolean = true;
  tagLoading: boolean = false;
  newTag: string = "";

  @Watch("dbTags")
  async onBdTagsChange() {
    
    if (this.dbTags && this.dbTags.length > 0) {
      if (!this.selected) this.selected = new Array<Tag>();
      this.dbTags.forEach((recordTag: RecordTag) => {
        this.selected.push(recordTag.tag);
      });
    }
  }

  async mounted() {
    this.data = await this.historyService.getTags();
  }

  get sAction() {
    return this.action ? "/" + this.action : "";
  }

  customLabel({ id, name, email, profileImage, identification }: any) {
    let label = name;
    return label;
  }

  onSelected(selected: BaseModel) {
    if (selected) {
      this.$emit("input", selected.id);
      this.$emit("select", selected);
      this.$emit("onChange", selected);
    }
  }

  getPerson(value?: any) {
    this.loading = true;
    if (this.timerFunction) {
      clearTimeout(this.timerFunction);
    }
    if (this.nombre) {
      this.timerFunction = setTimeout(() => {
        this.historyService.getTagsByCriteria(this.nombre).then(tags => {
          
          if (tags) {
            this.disabledAdd = true;
            if (this.data && this.data.length > 0) {
              tags.forEach((person: Tag) => {
                if (!this.data.some((x: Tag) => x.id == person.id)) {
                  this.data.unshift(person);
                }
              });
            } else {
              this.data = tags;
              this.loading = false;
            }
            this.loading = false;
          }
          
          if (tags.length == 0) {
            this.newTag = this.nombre;
            this.disabledAdd = false;
          }
        });
      }, 500);
    }
  }

  searchChange(text: string) {
    this.nombre = text;
    this.$emit("searchChange", text);
  }

  @Watch("selected")
  onSelectChange() {
    
    if (this.selected) {
      this.$emit("input", this.selected.id);
      this.$emit("selected", this.selected);
    } else {
      this.$emit("input", null);
      this.$emit("selected", null);
    }
  }

  @Watch("value", { immediate: true })
  onValueChange(value: any) {
    if (value) {
      if (this.searchPersonById && !isNaN(this.value)) {
        this.userService.getUserById(value).then(response => {
          this.selected = response;
        });
      }
    }
    if (value === null) {
      this.selected = value;
    }
  }

  @Watch("nombre")
  onNombreChange(value?: string) {
    if (value) {
      //this.getPerson(value);
    }
  }

  async saveTag() {
    if (this.newTag) {
      
      this.tagLoading = true;
      let tagModel = new Tag();
      tagModel.name = this.newTag;
      let data = await this.historyService.saveTag(tagModel);

      this.tagLoading = false;
      this.disabledAdd = true;
      this.newTag = "";
      if (!this.selected) {
        this.selected = new Array<Tag>();
        this.selected.push(data);
      } else {
        this.selected.push(data);
      }
    }
  }
}
